/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Rv_Cons_2Inputs */

const en_pc_rv_cons_2 = /** @type {(inputs: Pc_Rv_Cons_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complex edits can differ from Photoshop`)
};

const zh_pc_rv_cons_2 = /** @type {(inputs: Pc_Rv_Cons_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复杂编辑的效果可能与 Photoshop 不同`)
};

/**
* | output |
* | --- |
* | "Complex edits can differ from Photoshop" |
*
* @param {Pc_Rv_Cons_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_rv_cons_2 = /** @type {((inputs?: Pc_Rv_Cons_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Rv_Cons_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_rv_cons_2(inputs)
	return zh_pc_rv_cons_2(inputs)
});
export { pc_rv_cons_2 as "pc.rv.cons.2" }